import React, { useMemo, useContext, useCallback } from 'react';
import { LocalizationContext } from 'app/localization/Context';
import { HistoryStackContext } from 'app/home/general-components/HistoryStackContext';

// import { useMessageCenter } from 'app/model/MessageCenter';
import { DeviceType } from 'app/model/Device';
import { getHomeAvatar } from 'app/home/new-home/HomeList';

// import { ReactComponent as IconMessageCenter } from 'images/general/message-center.svg';
import { ReactComponent as IconDown } from 'images/general/down.svg';
// import { ReactComponent as IconMusicAnimated } from 'images/device/audio-controller/music-animated.svg';
import { ReactComponent as IconMusicNormal } from 'images/device/audio-controller/music-normal.svg';
import { ReactComponent as IconMic } from 'images/chat/mic-button.svg';

import './ProfileHeader.scss'


function ProfileHeader({ homesManager, devices, negotiatedProtocol, aiChatStartListening }) {
    const l = useContext(LocalizationContext);
    const s = l.strings;
    const hs = useContext(HistoryStackContext);

    // const { showNewMessageDot, markAllMessagesToRead } = useMessageCenter();
    // const showMessageCenterList = useCallback(() => {
    //     hs.push("/message_center/list");
    // }, [hs]);

    const onSwitchHomeClick = useCallback(() => {
        hs.push("/homes/switch");
    }, [hs]);

    const onAIChatClick = useCallback(() => {
        // aiChatStartListening(l.language);
        hs.push("/ai/chat");
    }, [hs]);

    const homeName = useMemo(() => {
        if (homesManager.activeHome.name) {
            return homesManager.activeHome.name;
        } else {
            return s.defaultHomeName;
        }
    }, [homesManager.activeHome.name, s.defaultHomeName]);

    const homeAvatar = useMemo(() => {
        if (homesManager.activeHome.avatar) {
            return getHomeAvatar(homesManager.activeHome.avatar, false);
        } else {
            return getHomeAvatar(5, false);
        }
    }, [homesManager.activeHome.avatar]);


    const [audioControllerDeviceStatus, openAudioControllerDevice] = useMemo(() => {
        const playerDevices = devices.filter(d => d.type === DeviceType.amplifier);
        if (playerDevices.length > 0) {
            for (let i = 0; i < playerDevices.length; i++) {
                const d = playerDevices[i];
                if (d.track_is_playing) {
                    return ["playing", () => {
                        hs.push("/devices/detail", { mac: d.mac });
                    }];
                }
            }

            return ["not-playing", () => {
                hs.push("/devices/detail", { mac: playerDevices[0].mac });
            }];
        } else {
            return ["no-device", undefined];
        }
    }, [hs, devices]);

    return (
        <div className="profile-header">
            {React.createElement(homeAvatar, { className: "home-image" })}
            <div className="home-section" onClick={onSwitchHomeClick}>
                <div className="name">{homeName}</div>
                <IconDown className="down-icon" />
            </div>
            <div />

            <div className="end-section">
                {((audioControllerDeviceStatus === "playing") || (audioControllerDeviceStatus === "not-playing")) ?
                    <IconMusicNormal className="music-icon" onClick={openAudioControllerDevice} />
                    : null}

                {/* message center */}
                {/* <div className="message-center-container">
                    <IconMessageCenter onClick={() => {
                        markAllMessagesToRead();
                        showMessageCenterList();
                    }} className="icon" />
                    {showNewMessageDot ? <div className="dot" /> : null}
                </div> */}
                
                {negotiatedProtocol.supportsAIChat ?
                    <IconMic onClick={onAIChatClick} /> : null}
            </div>
        </div>
    );
}

export default ProfileHeader;